import React, { useState } from "react";
import DataTable from "../UI/table/DataTable";
import { useQuery } from "react-query";
import {
  deleteCountries,
  getCountries,
  UpdateCountry,
} from "../../MyApi/admin/countries/countries";
import StatusBadge from "../UI/statusBadge";
import TableActions from "../UI/table/TableActions";
import AddCountryModal from "./storemodals/countriesmodal";
import i18next from "i18next";

const CountriesComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState("");

  const lang = i18next.language;

  const { data, isLoading, refetch } = useQuery(
    ["countries-data", lang],
    () => getCountries(lang)
  );

  const countriesColumns = [
    {
      label: "اسم الدولة",
      render: (row) => (
        <div className="d-flex align-items-center gap-3">
          <img src={row.flag} alt="" width={24} height={24} />
          <div>
            <h6>{row.name}</h6>
            <p className="desc">{row.id}</p>
          </div>
        </div>
      ),
    },
    { label: "كود الدولة", accessor: "code" },
    { label: "اسم العملة", accessor: "currency_name" },
    { label: "كود العملة", accessor: "currency_symbol" },
    { label: "وحدة العملة", accessor: "currency_unit" },
    { label: "عامل العملة", accessor: "currency_factor" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={() => openModal("edit", row.id)}
          deleteFn={deleteCountries}
          refetch={refetch}
          mutationKey={"deleteCountries"}
          id={row.id}
          queryKey={"countries-data"}
          editPermission="update_country"
          deletePermission="delete_country"
          togglePermission="update_country"
          toggleMutationKey={"toggle-update-country"}
          toggleFn={(id, status) => UpdateCountry({is_active: status, "_method": "PUT", lang: i18next.language}, i18next.language, id)}
          is_active={row.is_active}
        />
      ),
    },
  ];

  const systemData = data?.data?.countries || [];

  const openModal = (mode, id) => {
    setShowModal(true);
    setModalMode(mode);
    setModalId(id);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMode("add");
    setModalId("");
  };

  return (
    <>
      <DataTable
        actionLabel="إضافة الدول"
        createPermission="create_country"
        onAddClick={() => openModal("add")}
        title="الدول"
        columns={countriesColumns}
        data={systemData}
        isLoading={isLoading}
      />
    {showModal &&  <AddCountryModal
        show={showModal}
        onClose={closeModal}
        refetch={refetch}
        modalMode={modalMode}
        modalId={modalId}
      />}
    </>
  );
};

export default CountriesComponent;
